import React from 'react';

import { ListItem } from '@swf/first';

import { resultText, single } from './SingleResult.scss';

interface Props {
  text: string;
  description: string;
}

const SingleResult: React.FC<Props> = ({ text, description }) => (
  <ListItem
    primary={
      <span>
        <strong>{text}</strong>, {description}
      </span>
    }
    textOnly
    classes={{
      button: single,
      primaryText: resultText
    }}
  />
);

export default SingleResult;
